export const status = {
  job: {
    draft: "Draft",
    planned: "Planned",
    released: "Released",
    in_progress: "In progress",
    on_hold: "On hold",
    ready_for_delivery: "Ready for delivery",
    completed: "Completed",
    cancelled: "Cancelled",
  },
  operation: {
    not_ready: "Not ready",
    ready: "Ready",
    active: "Active",
    paused: "Paused",
    blocked: "Blocked",
    completed: "Completed",
  },
  task: {
    open: "Open",
    overdue: "Overdue",
    completed: "Completed",
  },
  customer: {
    lead: "Lead",
    active: "Active",
    archived: "Archived",
  },
  priority: {
    low: "Low",
    medium: "Medium",
    high: "High",
  },
  activity: {
    call: "Call",
    meeting: "Meeting",
    note: "Note",
    email: "Email",
    site_visit: "Site visit",
    other: "Other",
  },
  address: {
    billing: "Billing",
    shipping: "Shipping",
    site: "Site",
    other: "Other",
  },
  quote: {
    draft: "Draft",
    sent: "Sent",
    accepted: "Accepted",
    declined: "Declined",
    expired: "Expired",
  },
  rfq: {
    open: "Open",
    quoted: "Quoted",
    closed: "Closed",
  },
  salesOrder: {
    open: "Open",
    delivered: "Delivered",
    cancelled: "Cancelled",
  },
  product: {
    equipment: "Equipment",
    fabricated: "Fabricated item",
    component: "Component",
    service: "Service",
  },
  estimate: {
    material: "Material",
    labor: "Labour",
    work_center: "Work-centre time",
    outsourced: "Outsourced process",
    fixed: "Fixed / other",
  },
  production: {
    good: "Good",
    scrap: "Scrap",
    rework: "Rework",
  },
  reason: {
    scrap: "Scrap",
    rework: "Rework",
  },
  purchaseOrder: {
    draft: "Draft",
    issued: "Issued",
    partially_received: "Partially received",
    received: "Received",
    cancelled: "Cancelled",
  },
  invoice: {
    draft: "Draft",
    issued: "Issued",
    partially_paid: "Partially paid",
    paid: "Paid",
    overdue: "Overdue",
    void: "Void",
  },
  direction: {
    in: "In",
    out: "Out",
  },
  severity: {
    low: "Low",
    medium: "Medium",
    high: "High",
  },
};
